// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__daEMG","box-icon":"style_box-icon__pbVpb","title":"style_title__3uT3u"};